import Swiper from "swiper";
import { find, findAll } from "../utils/dom";


const PageSPFCNovo = () =>{
	const page = find(`[js-page="spfc-novo"]`);
	if(!page) return;

	const swiperNossaEquipe = new Swiper(".swiper-nossa-equipe",{
		slidesPerView: 1,
		spaceBetween: 8,
		autoplay: {
			delay: 4500,
			disableOnInteraction: false,
		},
		navigation: {
			nextEl: ".swiper-nossa-equipe .swiper-button-next",
			prevEl: ".swiper-nossa-equipe .swiper-button-prev",
		},
		breakpoints:{
			500:{
				slidesPerView: 2,
			},
			1024:{
				slidesPerView: 3,
			}
		}
	})
}

export default PageSPFCNovo;